"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiGrid = void 0;
exports.MuiGrid = {
    defaultProps: {
        columnSpacing: { mobileXs: "12px", mobileSm: "17px", sm: 4, lg: 5 },
        rowSpacing: 4,
        maxWidth: {
            mobileXs: "288px",
            mobileSm: "343px",
            sm: "540px",
            md: "720px",
            lg: "964px",
            xl: "1144px",
        },
    },
};
//# sourceMappingURL=grid.js.map